import styled from "styled-components";
import EventBoxBg from "@/styles/assets/images/img_event_video_bg.png";

export const EventExerciseBox = styled.div`
  gap: 10px;
  width: 100%;
  display: flex;
  overflow: visible;
  position: relative;
  flex-direction: column;
`;

export const EventExerciseTit = styled.h3`
  color: ${(props) => props.theme.colors.text4};
  display: flex;
  font-size: 1.8rem;
  font-weight: 600;
  align-items: center;
`;

export const EventExerciseTitSubTit = styled.div`
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.3rem;
  font-weight: 400;
  display: flex;
  white-space: pre-wrap;
`;

export const HighLight = styled.div`
  color: ${(props) => props.theme.colors.primary100};
  font-weight: 900;
`;

export const VideoBox = styled.div`
  width: 100%;
  color: #ffffff;
  padding: 8px;
  display: flex;
  font-size: 1.3rem;
  box-shadow: 0px 2px 16px -4px rgba(95, 95, 146, 0.1);
  align-items: center;
  border-radius: 10px;
  justify-content: space-between;

  /** 이벤트 운동 백그라운드 활성화 시 아래 코드 사용 */
  /* background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background:
    linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.1) 100%
    ),
    url(${EventBoxBg}) lightgray 50% / cover no-repeat; */
`;

export const EventExerciseInfoTxt = styled.div`
  gap: 16px;
  display: flex;
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.5rem;
  font-weight: 600;
  flex-direction: column;
  padding: 1.5px 0 0 0;

  span {
    font-weight: 500;
  }
`;

export const InfoTime = styled.div`
  color: ${(props) => props.theme.colors.black38};
  display: flex;
  font-size: 1.2rem;

  svg path {
    fill: #fff;
  }
`;

export const VideoListRow = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const VideoItem = styled.div`
  flex: 1;
  min-width: 0;
  cursor: pointer;
`;

export const PlayBtn = styled.button`
  width: 24px;
  height: 24px;
  border: none;
  display: flex;
  margin: 12px 0 0 0;
  background: #2f54eb0d;
  align-items: center;
  border-radius: 50%;
  justify-content: center;

  &:active {
    background: ${(props) => props.theme.colors.black50};
  }
`;
